import React, { useState } from 'react'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, SubmitHandler } from 'react-hook-form'
import { errorToast, successToast } from 'src/utils/toastService'
import { useUploadAITrainerExerciseMutation } from 'src/api/aiTrainerApi'

export type IFormInput = {
  name: string
  equipmentNeeded: string
  time: number,
  trainingLevel: string,
  instruction: string
}

export const formSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  equipmentNeeded: Yup.string().required('Equipment Needed is required'),
  time: Yup.number().required('Time is required'),
  trainingLevel: Yup.string().required('Training Level is required'),
  instruction: Yup.string().required('Instruction is required'),
})

type useUploadExerciseProps = {
  successCallback: () => void
}
const useUploadExcercise = ({ successCallback }: useUploadExerciseProps) => {
  const [file, setFile] = useState<File | null>(null)
  const {
    handleSubmit,
    control,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(formSchema),
    mode: 'all',
    defaultValues: {
      name: '',
      equipmentNeeded: '',
      time: 0,
      trainingLevel: '',
      instruction: '',
    },
  })
  const [uploadExercise, { isLoading: isLoadingUploadExercise }] = useUploadAITrainerExerciseMutation()

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files?.length) {
      setFile(e.target.files[0])
    }
  }

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    console.log(data, file)
    if (!file) {
      errorToast('Exercise image is required.')
      return
    }
    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('equipment_needed', data.equipmentNeeded)
    formData.append('time', data.time.toString())
    formData.append('training_level', data.trainingLevel)
    formData.append('instruction', data.instruction)
    formData.append('video', file)
    uploadExercise(formData)
      .unwrap()
      .then((res) => {
        console.log(res)
        successToast('Exercise uploaded successfully.')
        reset()
        setFile(null)
        successCallback()
      })
      .catch((err) => {
        console.log(err)
        errorToast('Unable to upload exercise.')
      })
  }

  return {
    file,
    handleFileChange,
    onSubmit: handleSubmit(onSubmit),
    control,
    errors,
    isLoadingUploadExercise,
  }
}

export default useUploadExcercise
